import { logSessionStart } from '../analytics';
import { generateV4UUID } from './identityGenerator';
import { tryGetParentWindowField } from './window';

export const sessionKey = 'insSessionId';

export const createNewSessionIfNeeded = async (storeId?: string) => {
  if (!window[sessionKey] && !tryGetParentWindowField(sessionKey)) {
    const sessionId = generateV4UUID();
    window[sessionKey] = sessionId;
    
    // Fetch geolocation data for the new session
    try {
      const { getGeolocation } = await import('../services/geolocation');
      const geolocationData = await getGeolocation();
      
      if (geolocationData && Object.keys(geolocationData).length > 0) {
        // Store geolocation data in sessionStorage for analytics to use
        if (typeof sessionStorage !== 'undefined') {
          sessionStorage.setItem('geolocation_session', JSON.stringify(geolocationData));
        }
      }
    } catch (geoError) {
      // Continue with session creation even if geolocation fails
    }
    
    logSessionStart(sessionId, storeId);
  }
};
